import { metrics } from '@opentelemetry/api';
export function getMeter() {
    return metrics.getMeter('webrtc-player');
}
//# sourceMappingURL=metrics.js.map